export default String.raw`
<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{ translations.Inquiries }}
	</div>
	<div class="inquiries-js container-js" data-template="partials/customer-profile/inquiries/inquiries.html">
		{% include 'partials/customer-profile/inquiries/inquiries-list.html' -%}
	</div>
</div>
`